module.exports = __webpack_public_path__ + "img/catch_sp.ef709fb0.png";